import request from '@/utils/request'
const BASE_URL = '/Requirement'

//软件需求
export default {
  list(data) {
    return request({
      url: BASE_URL + '/List',
      method: 'post',
      data
    })
  },
  info(id) {
    return request({
      url: BASE_URL + '/Info',
      method: 'get',
      params: { id }
    })
  },
  save(data) {
    return request({
      url: BASE_URL + '/Save',
      method: 'post',
      data
    })
  },
  submit(data){
    return request({
      url: BASE_URL + '/Submit',
      method: 'post',
      data
    })
  },
  pass(data){
    return request({
      url: BASE_URL + '/Pass',
      method: 'post',
      data
    })
  },
  back(data){
    return request({
      url: BASE_URL + '/Back',
      method: 'post',
      data
    })
  },
  delete(data) {
    return request({
      url: BASE_URL + '/Delete',
      method: 'post',
      data
    })
  },
  cancel(id) {
    return request({
      url: BASE_URL + '/Cancel',
      method: 'get',
      params: { id }
    })
  },
  getMyRequirements(params) {
    return request({
      url: BASE_URL + '/GetMyRequirements',
      method: 'get',
      params
    })
  },
  getMyToDos(params) {
    return request({
      url: BASE_URL + '/GetMyToDos',
      method: 'get',
      params
    })
  },
  uploadPicture: '/api' + BASE_URL + '/UploadPicture',
  uploadPicture2: '/api' + BASE_URL + '/UploadPicture2',
  getStat(params) {
    return request({
      url: BASE_URL + '/GetStat',
      method: 'get',
      params
    })
  },
  getDpStat(params) {
    return request({
      url: BASE_URL + '/GetDpStat',
      method: 'get',
      params
    })
  },
  getMonthStat(params) {
    return request({
      url: BASE_URL + '/GetMonthStat',
      method: 'get',
      params
    })
  },
}